import {
  AuditIcon,
  CloudUploadIcon,
  Color,
  IconSize,
  InformationFilledIcon,
  QuestionmarkFilledIcon,
} from "@enxcs/dap-ui-stratos";
import { FC, useMemo } from "react";
import { ExportStatusContainer, ExportStatusEnum, ExportStatusText } from "./ExportStatus.styles";
// import { t } from "i18next";
import { useTranslation } from "react-i18next";

export interface ExportStatusProps {
  currentStatus: number;
  alternativeName?: string;
}

const ExportStatus: FC<ExportStatusProps> = ({ currentStatus = 0, alternativeName }) => {
  const { t } = useTranslation();
  const statusDictionary = useMemo(
    () => [
      {
        icon: <CloudUploadIcon size={IconSize.V16} tone={Color.Orange.V40} />,
        statusName: t("status.inProgress"),
        name: ExportStatusEnum.PROCESSING,
      },
      {
        icon: <AuditIcon size={IconSize.V16} tone={Color.Teal.V40} />,
        statusName: t("status.generated"),
        name: ExportStatusEnum.GENERATED,
      },
      {
        icon: <InformationFilledIcon size={IconSize.V16} tone={Color.Red.V30} />,
        statusName: t("status.failed"),
        name: ExportStatusEnum.FAILED,
      },
      {
        icon: <AuditIcon size={IconSize.V16} tone={Color.SpringGreen.V40} />,
        statusName: t("status.exported"),
        name: ExportStatusEnum.EXPORTED,
      },
    ],
    [t],
  );

  const statusEntry = statusDictionary[currentStatus];

  if (!statusEntry) {
    return (
      <ExportStatusContainer status={ExportStatusEnum.UNKNOWN}>
        <QuestionmarkFilledIcon size={IconSize.V16} tone={Color.Red.V30} />
        <ExportStatusText status={ExportStatusEnum.UNKNOWN}>{t("status.unknown")}</ExportStatusText>
      </ExportStatusContainer>
    );
  }
  return (
    <ExportStatusContainer status={statusEntry.name}>
      {statusEntry.icon}
      <ExportStatusText status={statusEntry.name}>{alternativeName ?? statusEntry.statusName}</ExportStatusText>
    </ExportStatusContainer>
  );
};

export default ExportStatus;
